<script setup lang="ts">
import type { DateRange } from "reka-ui";
import { DateFormatter, getLocalTimeZone } from "@internationalized/date";

import { cn } from "~/lib/utils";

const { t, locale } = useI18n();
const df = new DateFormatter(locale.value);

const value = defineModel<DateRange>({
    required: true,
});
</script>
<template>
    <button
        :class="
            cn(
                'slt-placeholder slt-focus-outline relative flex h-[12.21vw] w-[13.23vw] items-center justify-center gap-2 rounded-full bg-base-silver font-normal text-base-black xs:h-[48px] xs:w-[52px] lg:h-[unset] lg:w-[205px] lg:justify-start lg:self-stretch lg:pl-[1.06vw] lg:pr-[0.79vw] 3xl:pl-[20.3px] 3xl:pr-[15.2px]',
            )
        "
    >
        <span
            class="pointer-events-none absolute right-0 top-0 h-[14px] w-[14px] rounded-full duration-200 ease-in-out"
            :class="
                cn(
                    'bg-primary-orange lg:scale-0',
                    !value.start ? 'scale-0' : 'scale-[100%]',
                )
            "
        />
        <SvgCalendar24 class="h-[6.1vw] w-[6.1vw] xs:h-[24px] xs:w-[24px]" />
        <span v-if="value.start" class="hidden text-sm lg:block">
            <template v-if="value.end">
                {{ df.format(value.start.toDate(getLocalTimeZone())) }}
                - {{ df.format(value.end.toDate(getLocalTimeZone())) }}
            </template>

            <template v-else>
                {{ df.format(value.start.toDate(getLocalTimeZone())) }}
            </template>
        </span>
        <span v-else class="hidden text-base-black/40 lg:block">
            {{ t("toolbar.date.start") }} —
            {{ t("toolbar.date.end") }}
        </span>
    </button>
</template>
